import React from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router";
import { Route, Switch } from "react-router-dom";

import CourseAreaDetails from "components/course-areas/CourseAreaDetails";
import Summary from "components/atar/Summary";
import AtarEligible from "components/atar/AtarEligible";
import AllSubjectsList from "./atar/AllSubjectsList";
import EmailModal from "./email/EmailModal";
import CATEGORIES from "utils/categories";
import { getEligibility } from "actions/eligibilityActions";
import SelectedCourses from "components/course-areas/SelectedCourses";
import PageNotFound from "./ui/PageNotFound";
import Studies from "./studies/Studies";
import AllCourses from "./course-areas/AllCourses";

class WindowStickyFooter extends React.Component {
  state = {
    modalVisible: false,
  };

  getUserSubjects = () => {
    const { userRecSubs, userOthSubs, userAddSubs } = this.props;
    const userSubjects = userRecSubs.concat(userOthSubs).concat(userAddSubs);
    return userSubjects;
  };

  // ------------------ Footer and App Functions ------------------ //

  // Modal Functions
  showModal = () => this.setState({ modalVisible: true });
  closeModal = () => this.setState({ modalVisible: false });

  handleSubmit = () => {
    const { recommendations_input_hash } = this.props;
    this.props.dispatch(
      getEligibility(this.getUserSubjects(), recommendations_input_hash),
      recommendations_input_hash
    );
  };

  render() {
    return (
      <div className="form-container ">
        <Switch>
          {/* Main Category Landing Pages */}
          {CATEGORIES.map((cat, i) => {
            const MyComponent = cat.component;
            return (
              <Route
                key={i}
                path={`/${cat.navlink}`}
                render={(props) => <MyComponent {...props} />}
                exact
              />
            );
          })}
          {/* Subpages branched from each Category */}

          <Route path="/studies" component={Studies} />
          <Route path="/course-areas/all-courses" component={AllCourses} />

          <Route
            path="/course-areas/selected-courses"
            component={SelectedCourses}
          />
          <Route path="/course-areas/:id" component={CourseAreaDetails} />

          <Route path="/summary" component={Summary} exact />
          <Route path="/summary/all-subjects" component={AllSubjectsList} />
          <Route path="/summary/atar-eligible" component={AtarEligible} exact />
          <Route path="*" component={PageNotFound} />
        </Switch>

        <EmailModal
          modalVisible={this.state.modalVisible}
          closeModal={this.closeModal}
        />
      </div>
    );
  }
}

const mapStateToProps = (store) => {
  // general
  const { email } = store.emailReducer;
  const { input } = store.inputReducer;

  const { userRecSubs } = store.pickRecSubReducer;
  const { userOthSubs } = store.pickOthSubReducer;
  const { userAddSubs } = store.pickAddSubReducer;

  // Recommendations
  const {
    recommendations_input_hash,
    eligibility_input_hash,
  } = store.hashReducer;

  return {
    // general
    email,
    input,

    userRecSubs,
    userOthSubs,
    userAddSubs,

    recommendations_input_hash,
    eligibility_input_hash,
  };
};

export default withRouter(connect(mapStateToProps)(WindowStickyFooter));
